<div class="row sticky-top bg-white mb-3" style="top:6.125rem">
  <div class="col-md-12">
    <app-alerting></app-alerting>
  </div>
</div>

<div class="row narrow-gutters always-enabled mb-1 g-2">
  <div class="col-auto">
    <button class="btn"
            [ngClass]="transitFilter.selectedOptions.length > 0 || transitFilter.deselectedOptions.length > 0 ? 'btn-danger' : 'btn-outline-info'"
            (click)="toggleFilter()">
      <span class="fa fa-filter m-0"></span>
    </button>
  </div>
  <div class="col col-md-auto ps-2 pe-2">
    <app-select [options]="transitDateFilterOptions" [(ngModel)]="transitDateFilterType"
                [formatter]="transitDateFilterTypeFormatter"
                (ngModelChange)="onDateTypeChanged($event)">
    </app-select>
  </div>
  <div class="col-3 col-md-auto pe-4" style="min-width: 19rem; height: 35px;">
    <app-date-range (ngModelChange)="onDateSelection($event)" [ngModel]="dateRange" [minDate]="'2023-01-01'">
    </app-date-range>
  </div>
  <div class="col-5 col-md pe-2">
    <app-filter (resultsFound)="renderFilteredItems()" [(ngModel)]="filterTerm" [searchFunction]="searchTransit"
                [showTooltip]="true"
                placeholder="Filter by mrn, container nr, etc..." [appAutoFocus]="true"></app-filter>
  </div>
  <div class="col-auto">
    <div class="dropdown">
      <button class="btn btn-plain text-primary d-inline-flex align-items-center py-1 p-md-2 p-1"
              data-bs-toggle="dropdown" aria-expanded="false">
        <div class="d-none d-md-block">
          {{ sortingFormatter(sortBy) }}
          <div class="d-inline-block"><i class="fa fa-fw fa-light fa-chevron-down ms-1"></i></div>
        </div>
        <div class="d-block d-md-none">
          <div class="d-inline-block">
            <i class="fa fa-fw fa-light fa-long-arrow-up"></i>
            <i class="fa fa-fw fa-light fa-long-arrow-down" [style.margin-left.rem]="-0.7"></i>
          </div>
        </div>
      </button>
      <ul class="dropdown-menu">
        @for (property of sortingProperties; track property) {
          <li>
            <button class="dropdown-item d-flex justify-content-between px-3"
                    [ngClass]="sortBy === property ? 'text-primary' : ''"
                    (click)="changeSorting(property)">
              <span>{{ sortingFormatter(property) }}</span>
              @if (sortBy === property) {
                <i class="fa fa-fw fa-light fa-check"></i>
              }
            </button>
          </li>
        }
      </ul>
    </div>
  </div>
  @if (appContext.isTransitEditor() || appContext.isAdmin()) {
    <div class="col-auto">
      <div class="btn-group">
        <button class="btn btn-info" data-bs-toggle="modal" data-bs-target="#newContainerManifestDeclaration">
          <span class="pe-2 fa fa-plus-circle"></span>New container manifest declaration
        </button>
        <button type="button" class="btn btn-info dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown">
        </button>
        <div class="dropdown-menu dropdown-menu-end">
          <button class="dropdown-item" tabindex="-1" data-bs-toggle="modal"
                  data-bs-target="#newManifestDeclarationContainerImport">
            New container manifest declaration (Excel import)
          </button>
          <button class="dropdown-item" tabindex="-1" data-bs-toggle="modal"
                  data-bs-target="#newBulkManifestDeclaration">New bulk manifest declaration
          </button>
          <button (click)="addNewContainerDeclaration()" class="dropdown-item" tabindex="-1"
                  style="border-top: 1px solid #dee2e6;">New blank container declaration
          </button>
          <button (click)="addNewBulkDeclaration()" class="dropdown-item" tabindex="-1">New blank bulk declaration
          </button>
        </div>
      </div>
    </div>
  }
</div>
<div class="row narrow-gutters my-3" [hidden]="!showFilter">
  <app-transit-filter class="px-0" (changed)="applyTransitFilters($event)" [transits]="getFilteredItems()">
  </app-transit-filter>
</div>

@if (visibleDeclarations; as declarations) {
  <app-transit-pagination #pagination [totalItems]="totalItems" [page]="page" [maxPerPage]="pageSize"
                          (pageChange)="goToPage($event)"
                          [class]="'accordion ' + (selectedCount > 0 ? 'items-selected' : '')" id="transitAccordion">
    @for (declaration of declarations; track declaration.summary.lrn) {
      @if ($any(declaration).terminal && ($index === 0)) {
        <div class="mt-3 row g-0 align-items-center">
          <div class="col-auto me-2 invisible">
            <div class="form-check form-check-inline m-0" style="height: 2.5rem">
              <input class="form-check-input m-0" type="checkbox"></div>
          </div>
          <div class="col py-1 ps-3 border border-white" style="border-width: 2px!important;">
            <span class="fa fa-fw fa-map-marker-alt text-portbase-blue pe-2 me-2"></span>
            <span class="ms-1 fw-bold text-dark"></span>
          </div>
        </div>
      }
      <div class="row g-0">
        <div class="col-auto me-2">
          <div class="form-check form-check-inline m-0 always-enabled" style="height: 2rem">
            <input [ngModel]="declaration.selected" (ngModelChange)="setSelected(declaration, $event)"
                   class="always-enabled form-check-input m-0" type="checkbox"></div>
        </div>
        <div class="col">
          <app-collapse #transitCollapse [collapse]="collapz" [showOnLoad]="declaration.isNewTransitDeclaration"
                        [deleteHandle]="declaration.isNewTransitDeclaration && removeNewDeclaration(declaration)">
            <div class="row g-0 py-1 px-3 align-items-center text-dark">
              <div class="col-1" style="min-width: 8rem">
                {{
                  declaration.isNewTransitDeclaration ? 'New declaration' :
                    declaration.summary.containerNumber || 'bulk'
                }}
              </div>
              <div class="col-1 small text-secondary cut-text" style="min-width: 12rem" [title]="declaration.summary.dischargeTerminalCode ?
        declaration.summary.dischargeTerminalCode + ' - ' + declaration.summary.dischargeTerminalName :
        declaration.summary.departureOfficeCode + ' - ' + declaration.summary.departureOfficeName">
                <span class="fa fa-sign-out-alt"></span>
                {{
                  declaration.summary.dischargeTerminalName ?
                    declaration.summary.dischargeTerminalName : declaration.summary.departureOfficeName
                }}
              </div>
              <div class="col-1 small text-secondary cut-text" style="min-width: 12rem"
                   [title]="declaration.summary.destinationsOfficeCode + ' - ' + declaration.summary.destinationsOfficeName">
                <span class="fa fa-sign-in-alt"></span>
                {{ declaration.summary.destinationsOfficeName }}
              </div>
              @if (!declaration.summary.inspectionStatus && !declaration.summary.sendDate) {
                <div
                  class="col-auto small text-secondary" style="min-width: 12rem">&nbsp;
                </div>
              }
              @if (declaration.summary.isReleased) {
                <div class="col-auto small text-secondary" style="min-width: 12rem"
                     [title]="determineStatusTooltip(declaration.summary)">
                      <span>
                        {{ declaration.summary.sentDate || declaration.summary.sendDate | date:'dd-MM-YYYY' }}
                        / {{ declaration.summary.transportExpiryDate | date:'dd-MM-YYYY' }}
                      </span>
                </div>
              }
              @if (!declaration.summary.isReleased) {
                @if (!!declaration.summary.inspectionStatus || !!declaration.summary.sendDate) {
                  <div
                    class="col-auto small text-secondary" style="min-width: 12rem"
                    [title]="determineStatusTooltip(declaration.summary)">
                    @if (declaration.summary.sendOnAta && !declaration.summary.sentDate) {
                      <span>
                            on ATA / + {{ transportTermToDays(declaration.summary.transportTerm) }} days
                          </span>
                    }
                    @if (declaration.summary.sentDate) {
                      <span>
                            {{ declaration.summary.sentDate | date:'dd-MM-YYYY' }} /
                        {{ calculateTransportExpiryDate(declaration.summary.sentDate, declaration.summary.transportTerm) }}
                          </span>
                    }
                    @if (!declaration.summary.sentDate && declaration.summary.sendDate) {
                      <span>
                            {{ declaration.summary.sendDate | date:'dd-MM-YYYY' }} /
                        {{ calculateTransportExpiryDate(declaration.summary.sendDate, declaration.summary.transportTerm) }}
                          </span>
                    }
                  </div>
                }
              }
              @if (!declaration.summary.mrn) {
                <div class="col-auto small text-secondary" style="min-width: 10rem">
                  &nbsp;
                </div>
              }
              @if (!!declaration.summary.mrn) {
                <div class="col-auto small text-secondary" style="min-width: 10rem">
                  {{ declaration.summary.mrn }}
                </div>
              }
              @if (appContext.isAdmin()) {
                <div class="col-auto d-none d-md-block small text-secondary cut-text" style="width: 6rem"
                     [title]="declaration.summary.declarantFullName">
                  <span class="fa fa-fw fa-users"></span>
                  <span class="ms-1">{{ declaration.summary.declarantFullName }}</span>
                </div>
              }
              <div class="text-end col d-none d-md-block text-dark">
                <app-transit-summary [setModel]="declaration.summary"
                                     [keepTooltipOpen]="transitCollapse.showing"></app-transit-summary>
              </div>
            </div>
          </app-collapse>
        </div>
      </div>
      <ng-template #collapz>
        <div class="collapse" data-bs-parent="#transitAccordion">
          <div class="py-3 ms-2">
            <app-transit-declaration [transit]="declaration" [ngClass]="{'disabled': !appContext.isTransitEditor()}">
            </app-transit-declaration>
          </div>
        </div>
      </ng-template>
    }
    <div class="row g-0 text-secondary">
      @if (declarations.length > 1) {
        <div class="col-auto">
          <label class="mt-3">
            <input [checked]="allSelected" (click)="toggleSelectAll()" class="always-enabled" type="checkbox">
            <span class="ms-2">Select all</span>
          </label>
        </div>
      }
    </div>
  </app-transit-pagination>
  @if (visibleDeclarations.length === 0) {
    <div class="text-center text-muted py-2">
      @if (filterTerm || hasDeclarationsInRange) {
        No matching declarations found.
      } @else {
        You haven’t added any declarations yet.
      }
    </div>
  }
}


<div id=newContainerManifestDeclaration class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false"
     tabindex="-1" role="dialog">
  <app-copy-containers-from-consignments [existing]="items"></app-copy-containers-from-consignments>
</div>

<div id=newBulkManifestDeclaration class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
     role="dialog">
  <app-copy-bulk-from-consignments [existing]="items"></app-copy-bulk-from-consignments>
</div>

<div id=newManifestDeclarationContainerImport class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false"
     tabindex="-1" role="dialog">
  <app-transit-declarations-from-containers [existing]="items"></app-transit-declarations-from-containers>
</div>

<div id=preselectedDeclaration class="modal fade" data-bs-backdrop="static" tabindex="-1" role="dialog">
  <app-batch-transit-declaration [items]="preselectedItems"></app-batch-transit-declaration>
</div>


@if (selectedCount > 0) {
  <div class="fixed-bottom row g-0 justify-content-center bg-white py-3 border-top">
    <div class="col-auto mx-1">
      <button class="btn btn-outline-info mx-1" (click)="printSelected(true)" style="min-width: 10rem" type="button">
        Print
      </button>
      <button class="btn btn-outline-info mx-1" (click)="printSelected(false)" style="min-width: 10rem" type="button">
        Print copy
      </button>
      <button class="btn btn-outline-info mx-1" (click)="downloadCsv()" style="min-width: 10rem" type="button">Download
        CSV
      </button>
    </div>
  </div>
}
